
<div class="container">
  <div class="InvalidErrorMsg" *ngIf="showError" >Invalid username or password. </div>
  <div class="login-wrapper">

    <div class="logo">
      <svg width="100%" height="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" fit=""
        preserveAspectRatio="xMidYMid meet" focusable="false">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M8.9421 3.81689H37.8197C39.2775 3.81689 40.2106 4.99967 39.9038 6.4554L34.2396 33.4541C33.9328 34.9119 32.5046 36.0926 31.0467 36.0926H2.16915C0.713421 36.0926 -0.219684 34.9119 0.0850037 33.4541L5.74923 6.4554C6.05603 4.99756 7.48425 3.81689 8.9421 3.81689ZM28.0311 13.4399L27.5275 15.577L34.1058 11.2754L29.5545 6.94415L29.0509 9.08543H14.7179C13.0929 9.08543 11.4489 10.4163 11.0659 12.0434L9.41341 19.0682C9.03255 20.6953 10.0186 22.1531 11.6457 22.1531H21.6538L22.1743 19.942L26.7235 24.3431L20.1325 28.6277L20.6382 26.4759H11.9398L12.4412 24.3494L5.87988 28.6722L10.4142 32.9695L10.9157 30.8367H25.3503C26.9753 30.8367 28.6193 29.5058 29.0023 27.8787L30.6844 20.7291C31.0674 19.102 30.0496 17.7711 28.4225 17.7711H18.3107L17.7965 19.9568L13.2305 15.6235L19.8363 11.2817L19.3284 13.4399H28.0311Z"
          fill="#3DAE2B"></path>
      </svg>

    </div>
    
    <div class="login-container">
      <div style="text-align: center;margin-top: 10px;">
        <h2>Login</h2>
      </div>

      <div class="form-container">
        <form [formGroup]="formDetails" class="form-content" autocomplete="off">
          <div>
            <mat-form-field appearance="fill" class="form-field-container">
              <mat-label>Username</mat-label>
              <input type="email" [formControl]="formDetails.get('email')" matInput #user type="text">
            </mat-form-field>
          </div>

          <div>
            <mat-form-field appearance="fill">
              <mat-label>Password</mat-label>
             
              <input [formControl]="formDetails.get('password')" matInput #password
                [type]="hide ? 'password' : 'text' ">
              <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide">

                <span *ngIf="hide">
                  <img src="../../../assets/images/visible_off.svg" />
                </span>


                <span *ngIf="!hide">
                  <img src="../../../assets/images/visible.svg" />
                </span> 
               </button>
            </mat-form-field>
          </div>

          <div style="margin: 20px 0px;">

            <app-button type="login" text="Login" (clickCallback)="onSubmit()" [ngClass]="{'disabled':formDetails.get('email').value === '' || formDetails.get('password').value === '' }"></app-button>

            <!-- <button (click)="onSubmit()" mat-button
                      [ngClass]="disable == true ? 'disable-login':'login-button'">Log In</button> -->
          </div>
        </form>

        <div style="text-align: center;font-size: 15px;">
          <a [routerLink]="forgotPasswordLink" class="Router">Forgot Password</a>
        </div>
      </div>

    </div>
  </div>

</div>